import { SttAPI } from "../apis/stt";

export async function speachToTextByWav(file: File) {
  if (file.type !== "audio/wav")
    throw new Error("檔案類型錯誤，請確認為 audio/wav");

  const payload = new FormData();
  payload.append("file", file);

  const response = await fetch(SttAPI.speechToTextByWav().url, {
    method: SttAPI.speechToTextByWav().method,
    body: payload,
  });

  const json = await response.json();

  if (response.status !== 200) {
    console.error(json);
    return { message: "無法辨識語音，請重新錄音", isError: true };
  }

  return json;
}
